import { TimePickerValue } from './time-picker';

/* istanbul ignore file */
export function validateDefaultTimeFormat(value: string): TimePickerValue | undefined {
  // Validate HH:mm format
  if (value.length > 5) {
    return undefined;
  }

  const timeParts = value.split(':');
  if (timeParts.length !== 2) {
    return undefined;
  }

  const hours = parseInt(timeParts[0], 10);
  const minutes = parseInt(timeParts[1], 10);
  const timeValue: TimePickerValue = { hours, minutes };
  const validTime = hours <= 23 && hours >= 0 && minutes <= 59 && minutes >= 0;
  if (validTime) {
    return timeValue;
  }
  return undefined;
}

export function validateHoursWithoutMinutes(value: string): TimePickerValue | undefined {
  // Validate HH format
  if (value.length > 2) {
    return undefined;
  }

  const hours = parseInt(value, 10);
  const timeValue: TimePickerValue = { hours, minutes: 0 };
  const validTime = hours <= 23 && hours >= 0;
  if (validTime) {
    return timeValue;
  }
  return undefined;
}

export function validateHoursMinutesWithoutColon(value: string): TimePickerValue | undefined {
  // Validate HHmm format
  if (value.length !== 4) {
    return undefined;
  }

  const hours = parseInt(value.slice(0, 2), 10);
  const minutes = parseInt(value.slice(2, 4), 10);
  const timeValue: TimePickerValue = { hours, minutes };
  const validTime = hours <= 23 && hours >= 0 && minutes <= 59 && minutes >= 0;
  if (validTime) {
    return timeValue;
  }
  return undefined;
}
